import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ArrowUpOnSquareIcon from "@heroicons/react/24/solid/ArrowUpOnSquareIcon";
import {
  Box,
  Button,
  Container,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";
import { CustomersSearch } from "@/sections/customer/customers-search";
import { useGetFeatureModelQuery } from "@/app/features/FeatureModel/featureModelApiSlice";
import FeatureModelModal from "./components/FeatureModelModal";
import FeatureModelListing from "./components/FeatureModelListing";

export default function FeaturePage() {
  const [search, setSearch] = useState("");
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 100,
    page: 0,
  });
  const { data, isLoading, isFetching, error } = useGetFeatureModelQuery({
    page: paginationModel.page + 1,
    limit: paginationModel.pageSize,
    search: search,
  });

  const [rowCountState, setRowCountState] = useState(data?.count || 0);

  const [selectedPopularSearch, setselectedPopularSearch] = useState({});
  const [isPopularSearchModalOpen, setisPopularSearchModalOpen] =
    useState(false);

  const handleSelectedPopularSearchModalClose = () => {
    setisPopularSearchModalOpen(false);
  };

  const handleSelectPopularSearch = (PopularSearch) => {
    setselectedPopularSearch(PopularSearch);
    setisPopularSearchModalOpen(true);
  };

  useEffect(() => {
    setRowCountState((prevRowCountState) =>
      data?.data?.total !== undefined ? data?.data?.total : prevRowCountState
    );
  }, [data, isLoading]);

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 8,
      }}
    >
      {selectedPopularSearch && (
        <FeatureModelModal
          open={isPopularSearchModalOpen}
          handleClose={handleSelectedPopularSearchModalClose}
          selectedPopularSearch={selectedPopularSearch}
        />
      )}

      <Container maxWidth="xl">
        <Stack spacing={3}>
          <Stack direction="row" justifyContent="space-between" spacing={4}>
            <Typography variant="h4">Feature Model</Typography>
            <Button
              color="inherit"
              startIcon={
                <SvgIcon fontSize="small">
                  <ArrowUpOnSquareIcon />
                </SvgIcon>
              }
              variant="contained"
              component={Link}
              to="/feature-model/create"
            >
              Add
            </Button>
          </Stack>
          <CustomersSearch search={search} setSearch={setSearch} />
          <FeatureModelListing
            isLoading={isLoading || isFetching}
            error={error}
            data={data?.data}
            rowCountState={rowCountState}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            handleSelectPopularSearch={handleSelectPopularSearch}
          />
        </Stack>
      </Container>
    </Box>
  );
}
